module.exports = __webpack_public_path__ + "assets/media/WelcomeVideo.682210a2.mp4";